export default "__VITE_ASSET__idE7lMMl__"